import { apiClient } from './apiClient';
import { WhatsAppApiKey, WhatsAppWebhook } from '../../types/models/whatsapp';

export const apiKeyService = {
  listKeys: async () => {
    const { keys } = await apiClient.get<{ keys: WhatsAppApiKey[] }>('/api-keys');
    return keys;
  },
  createKey: async (name: string, scopes: string[]) => {
    return apiClient.post<{ id: string; token: string; prefix: string }>('/api-keys', { name, scopes });
  },
  revokeKey: async (id: string) => {
    return apiClient.delete<{ success: boolean }>(`/api-keys/${id}`);
  },
  
  listWebhooks: async () => {
    const { webhooks } = await apiClient.get<{ webhooks: WhatsAppWebhook[] }>('/webhooks');
    return webhooks;
  },
  createWebhook: async (url: string, events: string[], secret: string) => {
    return apiClient.post<{ id: string }>('/webhooks', { url, events, secret });
  },
  deleteWebhook: async (id: string) => {
    return apiClient.delete<{ success: boolean }>(`/webhooks/${id}`);
  },

  listTeamMembers: async () => {
    // This uses a generic firebase admin read directly, or a custom endpoint?
    // Oh, wait, the instructions don't mention a backend endpoint for listing admins. 
    // They say: "Roles: agent, supervisor, admin. Settings UI for member list and role assignment."
    // Let's create an endpoint in integrationRoutes.js for this.
    const { members } = await apiClient.get<{ members: any[] }>('/team');
    return members;
  },
  updateTeamMemberRole: async (id: string, whatsappRole: string) => {
    return apiClient.patch<{ success: boolean }>(`/team/${id}`, { whatsappRole });
  }
};
